/**
 * Research Engine — deterministic merge engine.
 *
 * Composes an ordered list of knowledge fragments (base-first → most specific
 * last) into the merged brief fields, driven entirely by the field spec:
 *   - OVERRIDE fields take the most-specific non-empty value.
 *   - UNION / *_REF fields become a deduped list, most-specific first.
 *
 * Pure and deterministic: same fragments in the same order → identical output.
 */

import { RESEARCH_FIELDS, MERGE } from './researchSchema';

const isNonEmptyStr = (v) => typeof v === 'string' && v.trim().length > 0;

/**
 * @param {Object[]} orderedFragments  base-first, most-specific last.
 * @returns {Object}  the merged brief fields (no meta).
 */
export const mergeFragments = (orderedFragments) => {
  const merged = {};

  RESEARCH_FIELDS.forEach(({ key, merge }) => {
    if (merge === MERGE.OVERRIDE) {
      let value = null;
      orderedFragments.forEach((frag) => {
        if (frag && isNonEmptyStr(frag[key])) value = frag[key]; // last non-empty wins
      });
      merged[key] = value;
      return;
    }

    // UNION / GENOME_REF / PATTERN_REF: dedupe, most-specific first.
    const seen = new Set();
    const out = [];
    for (let i = orderedFragments.length - 1; i >= 0; i--) {
      const list = orderedFragments[i] && orderedFragments[i][key];
      if (!Array.isArray(list)) continue;
      list.forEach((item) => {
        if (isNonEmptyStr(item) && !seen.has(item)) { seen.add(item); out.push(item); }
      });
    }
    merged[key] = out;
  });

  return merged;
};
